import experiment from 'experiment';
import type { PagesData } from 'types/documentServices';
const tpaTypeUtils = {
  isTPA,
  isTPASpecialPage,
  isPageNotVisibleInPagesMenu,
};

function isTPA(pageData: AnyFixMe) {
  return !!pageData.tpaApplicationId; // not (undefined or null or 0)
}

function isTPASpecialPage(
  dsRead: AnyFixMe,
  pageData: AnyFixMe,
  onlyStaticPages?: AnyFixMe,
) {
  if (!tpaTypeUtils.isTPA(pageData)) {
    return false;
  }

  const isMultiSection = dsRead.pages.isPageContainsTPAMultiSectionComp(
    pageData.id,
  );

  const onlyStaticFiltered =
    !onlyStaticPages ||
    !dsRead.routers.getRouterDataForPageIfExist(pageData.id);

  return isMultiSection && onlyStaticFiltered;
}

function isPageNotVisibleInPagesMenu(dsRead: AnyFixMe, pageData: PagesData) {
  if (experiment.isOpen('se_appDefIdUpdates')) {
    return dsRead.tpaV2.isPageMarkedAsHideFromMenu(
      pageData.appDefinitionId,
      pageData.tpaPageId,
    );
  }

  return dsRead.tpa.isPageMarkedAsHideFromMenu(
    pageData.tpaApplicationId,
    pageData.tpaPageId,
  );
}

export default tpaTypeUtils;
